import styled from 'styled-components'

import onboardingFirstReward from 'images/onboarding_first_reward.png'
import particleAnimation from 'images/lottiefile/particle.json'
import LottieLoader from 'components/containers/common/LottieLoader'

const FirstCertifacationModal = ({ onStartClick }) => {
  return (
    <>
      <FullScreen>
        <Modal>
          <Title>3일 챌린지</Title>

          <Description>
            두번만 더 연속인증하면<br />
            습관으로 굳혀질 확률이 2배나 더 높아요!
          </Description>

          <RewardImg src={onboardingFirstReward} />

          <StartBtn onClick={onStartClick}>시작하기</StartBtn>
        </Modal>
      </FullScreen>

      <LottieLoader
        lottieOptions={{
          loop: false,
          autoplay: true,
          renderer: 'svg',
          animationData: particleAnimation,
        }}
        style={{
          position: 'absolute',
          top: '0',
          bottom: 'calc(100vw * (94 / 375))',
          left: '0',
          right: '0',
          margin: 'auto',
          width: '100%',
          zIndex: 500, 
        }}
      />
    </>
  )
}

const FullScreen = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-start;
  align-items: stretch;
  width: 100vw;
  height: 100vh;
  background: rgba(48, 48, 48, 0.4);
  z-index: 400;
`

const Modal = styled.div`
  background-color: #FFF;
  border-radius: calc(100vw * (30 / 375)) calc(100vw * (30 / 375)) 0 0;
  padding: 0 calc(100vw * (20 / 375));
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (22 / 375));
  color: #000;
  margin-top: calc(100vw * (33 / 375));
`

const Description = styled.div`
  font-weight: 400;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (26 / 375));
  color: #000;
  text-align: center;
  margin-top: calc(100vw * (14 / 375));
`

const RewardImg = styled.img`
  margin: calc(100vw * (25 / 375)) 0;
  width: calc(100vw * (265 / 375));
  height: calc(100vw * (120 / 375));
`

const StartBtn = styled.button`
  width: 100%;
  height: calc(100vw * (64 / 375));
  background: #FFCF19;
  border-radius: calc(100vw * (5 / 375));
  font-weight: 700;
  font-size: calc(100vw * (18 / 375));
  line-height: calc(100vw * (22 / 375));
  color: #121212;
  margin-bottom: calc(100vw * (30 / 375));
`

export default FirstCertifacationModal;